import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19aaa0f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "set" }
const _hoisted_2 = { style: {"fontsize":"18px","fontWeight":"bold","color":"#333"} }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputTitle" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = { style: {"fontsize":"19px","fontWeight":"bold","color":"#333"} }
const _hoisted_7 = { class: "inputTitle" }
const _hoisted_8 = { class: "inputTitle" }
const _hoisted_9 = { class: "inputTitle" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_11 = { class: "dialog-footer" }
const _hoisted_12 = { style: {"fontsize":"18px","fontWeight":"bold","color":"#333"} }
const _hoisted_13 = { class: "inputTitle" }
const _hoisted_14 = { class: "inputTitle" }
const _hoisted_15 = { class: "dialog-footer" }
const _hoisted_16 = { style: {"fontsize":"18px","fontWeight":"bold","color":"#333"} }
const _hoisted_17 = { class: "inputTitle" }
const _hoisted_18 = { class: "inputTitle" }
const _hoisted_19 = { class: "inputTitle" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_21 = { class: "dialog-footer" }
const _hoisted_22 = { style: {"fontsize":"18px","fontWeight":"bold","color":"#333"} }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { style: {"margin-bottom":"10px"} }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "inputTitle" }
const _hoisted_27 = { class: "inputTitle" }
const _hoisted_28 = {
  key: 0,
  class: "dialog-footer"
}
const _hoisted_29 = {
  key: 1,
  class: "dialog-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_edit = _resolveComponent("edit")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.langObj.l0239), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 12,
          class: "row1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.langObj.l0201), 1)
          ]),
          _: 1
        }),
        (_ctx.user.type == 0)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 4,
              class: "row2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSetLoginPwdAlert = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_edit)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.langObj.l0119), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 4,
              class: "row2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLoginPwdAlert = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_edit)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.langObj.l0220), 1)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.langObj.l0120), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 12,
          class: "row1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.langObj.l0202), 1)
          ]),
          _: 1
        }),
        (_ctx.user && _ctx.user.payPassword && _ctx.user.payPassword.length > 0)
          ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 4,
              class: "row2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPayPwdAlert = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_edit)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.langObj.l0220), 1)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 4,
              class: "row2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSetPayPwdAlert = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { size: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_edit)
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.langObj.l0119), 1)
              ]),
              _: 1
            }))
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showSetLoginPwdAlert,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showSetLoginPwdAlert) = $event)),
      width: "400px",
      "close-on-click-modal": false,
      "before-close": _ctx.closeSetLoginPwd
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.langObj.l0221), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeSetLoginPwd()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langObj.l0005), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"margin-left":"20px"},
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setLoginPwd()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langObj.l0004), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.langObj.l0239), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputNewPwd,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputNewPwd) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0200,
            maxlength: "6"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.langObj.l0222), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputNewPwdC,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputNewPwdC) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0203,
            maxlength: "6"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showLoginPwdAlert,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showLoginPwdAlert) = $event)),
      width: "400px",
      "close-on-click-modal": false,
      "before-close": _ctx.closeUpdateLoginPwd
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.langObj.l0206), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeUpdateLoginPwd()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langObj.l0005), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"margin-left":"20px"},
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateLoginPwd()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langObj.l0004), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.langObj.l0205), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputOriPwd,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inputOriPwd) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0223,
            maxlength: "12"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.langObj.l0204), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputNewPwd,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.inputNewPwd) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0200,
            maxlength: "12"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.langObj.l0231), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputNewPwdC,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.inputNewPwdC) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0203,
            maxlength: "12"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createElementVNode("div", {
              style: {"color":"#418cfa"},
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.forgetPwd(0)))
            }, _toDisplayString(_ctx.langObj.l0238) + "？", 1),
            _createElementVNode("div", {
              style: {"color":"#418cfa","margin-left":"10px"},
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.contactService()))
            }, _toDisplayString(_ctx.langObj.l0237), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showSetPayPwdAlert,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.showSetPayPwdAlert) = $event)),
      width: "400px",
      "close-on-click-modal": false,
      "before-close": _ctx.closeSetPayPwd
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.langObj.l0235), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_15, [
          _createVNode(_component_el_button, {
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.closeSetPayPwd()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langObj.l0005), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"margin-left":"20px"},
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setPayPwd()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langObj.l0004), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.langObj.l0120), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputNewPwd,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.inputNewPwd) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0230,
            maxlength: "6"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.langObj.l0236), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputNewPwdC,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.inputNewPwdC) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0234,
            maxlength: "6"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showPayPwdAlert,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.showPayPwdAlert) = $event)),
      width: "400px",
      "close-on-click-modal": false,
      "before-close": _ctx.closeUpdatePayPwd
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.langObj.l0226), 1)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_21, [
          _createVNode(_component_el_button, {
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.closeUpdatePayPwd()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langObj.l0005), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"margin-left":"20px"},
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.updatePayPwd()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.langObj.l0004), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.langObj.l0227), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputOriPwd,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.inputOriPwd) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0228,
            maxlength: "6"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.langObj.l0229), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputNewPwd,
            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.inputNewPwd) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0230,
            maxlength: "6"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.langObj.l0231), 1),
        _createElementVNode("form", null, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.inputNewPwdC,
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.inputNewPwdC) = $event)),
            "show-password": "",
            placeholder: _ctx.langObj.l0234,
            maxlength: "6"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode(_component_el_row, { style: {"margin-top":"10px"} }, {
          default: _withCtx(() => [
            _hoisted_20,
            _createElementVNode("div", {
              style: {"color":"#418cfa"},
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.forgetPwd(1)))
            }, _toDisplayString(_ctx.langObj.l0238) + "？", 1),
            _createElementVNode("div", {
              style: {"color":"#418cfa","margin-left":"10px"},
              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.contactService()))
            }, _toDisplayString(_ctx.langObj.l0237), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showForgetPwdAlert,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.showForgetPwdAlert) = $event)),
      width: "400px",
      "close-on-click-modal": false
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.alertType == 0 ? _ctx.langObj.l0224 : _ctx.langObj.l0225), 1)
      ]),
      footer: _withCtx(() => [
        (_ctx.forgetStep == 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
              _createVNode(_component_el_button, {
                onClick: _cache[33] || (_cache[33] = ($event: any) => {
    _ctx.showForgetPwdAlert = false;
_ctx.forgetStep = 0;
_ctx.inputCode = '';
                        })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.langObj.l0005), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-left":"20px"},
                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.nextAction()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.langObj.l0111), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.forgetStep == 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
              _createVNode(_component_el_button, {
                onClick: _cache[35] || (_cache[35] = ($event: any) => {
    _ctx.forgetStep = 0;
_ctx.inputCode = '';
                        })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.langObj.l0241), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                style: {"margin-left":"20px"},
                onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.forgetResetPwd()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.langObj.l0242), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (_ctx.forgetStep == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.langObj.l0246.replace(
                            "{X}",
                            "+" +
                            _ctx.user.phone.substring(0, 2) +
                            _ctx.user.phone.substring(3, 6) +
                            "****" +
                            _ctx.user.phone.substring(_ctx.user.phone.length - 3, _ctx.user.phone.length),
                        )), 1),
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, {
                    span: 17,
                    offset: 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.inputCode,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.inputCode) = $event)),
                        placeholder: _ctx.langObj.l0140,
                        maxlength: "6"
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 1,
                    offset: 0
                  }),
                  _createVNode(_component_el_col, {
                    span: 6,
                    offset: 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { onClick: _ctx.sendCode }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.sendTitle), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.langObj.l0240), 1),
              _createElementVNode("form", null, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.inputNewPwd,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.inputNewPwd) = $event)),
                  "show-password": "",
                  placeholder: _ctx.langObj.l0232,
                  maxlength: _ctx.alertType == 0 ? 12 : 6
                }, null, 8, ["modelValue", "placeholder", "maxlength"])
              ]),
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.langObj.l0231), 1),
              _createElementVNode("form", null, [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.inputNewPwdC,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.inputNewPwdC) = $event)),
                  "show-password": "",
                  placeholder: _ctx.langObj.l0233,
                  maxlength: _ctx.alertType == 0 ? 12 : 6
                }, null, 8, ["modelValue", "placeholder", "maxlength"])
              ])
            ]))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}